module.exports = __webpack_public_path__ + "static/media/WinterborneHome2.f6fd31e9.jpg";